<template>
    <div id="home" ref="home_main" style="display:block">
        <el-container class="con_section">
            <el-header class="blueheader">
                <el-row style="height: 60px;">
                    <el-col :span="4"><h2 class="headlogo">美团安全修复提示（Meituan Security Fix Guide）</h2></el-col>
                    <div style="text-align: right; float: right;">
                        <el-dropdown placement="top" @command="handleCommand" trigger="click" style="height:60px;">
                            <img class="el-dropdown-link" :src="imgUrl"
                                 style="margin:10px;border-radius:50%;width:40px;height:auto;"/>
                            <el-dropdown-menu slot="dropdown" style="margin-top:0;">
                                <el-dropdown-item :disabled="dropdown_item.disabled">{{userName}} {{mis_id}}
                                </el-dropdown-item>
                                <el-dropdown-item command="2-0" :divided="dropdown_item.divided">退出</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div style="text-align:center; float: right;">
                        <el-menu class="el-menu" mode="horizontal">
                            <el-menu-item index="whitelist_apply" @click="whitelist_apply">
                                白名单申请 ( Whitelist Application )
                            </el-menu-item>
                        </el-menu>
                    </div>
<!--                    <div style="text-align:center; float: right;">-->
<!--                        <el-menu class="el-menu" mode="horizontal">-->
<!--                            <el-menu-item index="whitelist_apply" @click="usercert_apply">-->
<!--                                证书申请-->
<!--                            </el-menu-item>-->
<!--                        </el-menu>-->
<!--                    </div>-->
                    <div style="text-align: center;float: right; padding: 0 20px;" >
                      <el-dropdown trigger="click" @command="handleLanguageChange">
                        <span class="lang-switcher">
                          <i class="el-icon-global"></i>
                          Language<i class="el-icon-arrow-down"></i>
                        </span>

                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                              v-for="lang in languages"
                              :key="lang.value"
                              :command="lang.value"
                              :class="{ 'selected': lang.value === currentLang }"
                          >
                            {{ lang.label }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div style="text-align: center;float: right; padding: 0 20px;" v-if="is_manager">
                      <el-dropdown @command="handleMenuSelect" trigger="click">
                              <span class="el-dropdown-link">
                                  <i class="el-icon-setting"></i>
                                      菜单管理
                                  <i class="el-icon-arrow-down el-icon--right"></i>
                              </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="addItem">添加菜单</el-dropdown-item>
                          <el-dropdown-item command="updateItem">编辑菜单</el-dropdown-item>
                          <el-dropdown-item command="deleteItem">删除菜单</el-dropdown-item>
                          <el-dropdown-item command="addLangIndex">添加页面语言映射</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                </el-row>
            </el-header>
            <el-container style="margin-top: 60px;">
                <div style="width: 300px">
                    <el-scrollbar>
                        <el-aside style="width: 300px">
                            <el-menu :default-active="activeItem"
                                     :default-openeds="openItems"
                                     class="el-menu-vertical"
                                     @select="handleSelect"
                                     unique-opened
                                     style="height: calc(100% - 40px); overflow-y: auto; width: 300px;">
                                <template>
                                    <!-- 一层-->
                                    <el-submenu :index="item.value+''" v-for="item in documentItems">
                                        <template slot="title"><i class="el-icon-menu"></i>{{item.label}}</template>
                                        <!--二层-->
                                        <div v-for="child in item.children">
                                            <el-menu-item :index="child.value+''"
                                                          v-if="child.children == null"
                                                          style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                {{child.label}}
                                            </el-menu-item>
                                            <!--三层-->
                                            <el-submenu :index="child.value+''" v-else>
                                                <template slot="title"><i class="el-icon-menu"></i>{{child.label}}</template>
                                                <div v-for="childOne in child.children">
                                                    <el-menu-item :index="childOne.value+''"
                                                                  v-if="childOne.children == null"
                                                                  style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                        {{childOne.label}}
                                                    </el-menu-item>
                                                    <!--四层-->
                                                    <el-submenu :index="childOne.value+''" v-else>
                                                        <template slot="title"><i class="el-icon-menu"></i>{{childOne.label}}
                                                        </template>
                                                        <el-menu-item :index="childTwo.value+''"
                                                                      v-for="childTwo in childOne.children">{{childTwo.label}}
                                                        </el-menu-item>
                                                    </el-submenu>
                                                </div>
                                            </el-submenu>
                                        </div>
                                    </el-submenu>
                                </template>
                            </el-menu>
                        </el-aside>
                    </el-scrollbar>
                </div>
                <el-main class="home_main">
                    <div class="router-view-container">
                        <router-view></router-view>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    import store from '../vuex/service/store'
    import axios from 'axios'
    import {mapState} from 'vuex';
    import {sso} from '../util/SSOUtil';
    import errorCode from '../util/ErrorCode';

    export default {
        mounted: function () {
            let vm = this;
            if (vm.token === "") {
                let token = vm.getCookie("access-token");
                if (token != null) {
                    vm.$store.commit('UPDATETOKEN', token);
                    vm.token = token;
                }
            }
            this.$nextTick(() => {
                vm.getUser();
            });
            this.$nextTick(() => {
                vm.buildMenuList();
            });
        },
        computed: mapState({
            selectItemList: function (state) {
                return state.selectItemList;
            },
            selectDocument: function (state) {
                return state.selectDocument;
            },
            activeItem: function (state) {
                return state.activeItem;
            },
            openItems: function (state) {
                return state.openItems;
            },
            cookieName: function (state) {
                return state.cookieName;
            },
            token: function (state) {
                return state.token;
            },
            getDocumentItem: function (state) {
                return state.documentItem;
            },
            getuserAPI: function (state) {
                return state.getuserAPI;
            },
            logoutRediret: function (state) {
                return state.logoutRediret;
            },
            selectDirItems: function (state) {
                return state.selectDirItems;
            },
          currentLang: function(state) {
            return state.currentLang;
          },
          currentLangLabel() {
            const lang = this.languages.find(l => l.value === this.currentLang)
            return (lang && lang.label) || ''
          }
        }),
        methods: {
          buildMenuList() {
              let vm = this;
              if (vm.documentItems) {
                  return;
              }
              axios.get(vm.selectItemList, {
                  withCredentials: true
              }).then((response) => {
                  let responseData = response.data;
                  errorCode(responseData);
                  let itemList = response.data.data;
                  if (!itemList || itemList.length === 0) {
                      return;
                  }
                  itemList[0].disabled = true;
                  vm.documentItems = itemList;
              }).catch(function () {
                  vm.documentItems = null;
              });
              setTimeout(function () {
                  vm.buildMenuList();
              }, 100000);
          },
          whitelist_apply() {
            this.$router.push({path: '/whiteApply'});
          },
          usercert_apply() {
              this.$router.push({path: '/userCertApply'});
          },
          handleSelect(key, keyPath) {
              this.$router.push({path: '/templateHtml', query: {index: key}});
          },
          getCookie(name) {
              var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
              if (arr = document.cookie.match(reg))
                  return unescape(arr[2]);
              else
                  return null;
          },
          handleMenuSelect(command) {
              if (this.$store.state.is_manager) {
                  this.$router.push({path: `/${command}`});
              } else {
                  this.$notify({
                      title: '没有权限',
                      message: '你没有操作当前菜单的权限',
                      type: 'error'
                  });
              }
          },
          handleCommand(command) {
              if (command === "2-0") {
                  sso.logout();
              }
          },
          getUser() {
              let vm = this;
              if (vm.user && vm.user !== '') {
                  return;
              }
              if (vm.user == null || vm.user === "") {
                  vm.user = vm.getCookie("username");
                  document.cookie = "ssoid=" + vm.getCookie("access-token");
                  axios.get(vm.getuserAPI, {
                      withCredentials: true
                  }).then((response) => {
                      let responseData = response.data;
                      errorCode(responseData);
                      if (response.data.code !== 0) {
                          return;
                      }
                      let user = response.data.data;
                      vm.user = user;
                      vm.userName = user.name;
                      vm.mis_id = user.login;
                      vm.is_manager = response.data.isManager;
                      vm.$store.commit('managerAuthority', vm.is_manager);
                      let loginName = user.login;
                      vm.userMis = loginName;
                      let avatarUrl = response.data.avatarUrl;
                      if (typeof loginName !== 'undefined') {
                          this.imgUrl = avatarUrl;
                          this.$refs["home_main"].style.display = "block";
                      }
                  }).catch(function (error) {
                      vm.requesterrorinfo(error)
                  });
                  setTimeout(function () {
                      vm.getUser();
                  }, 100000);
              }
          },
          requesterrorinfo(error) {
                var vm = this;
                if (error.response) {
                    var code = error.response.status;
                    if (code == 401) {
                        window.location = vm.loginRediret;
                    } else {
                        if (code == 404) {
                            vm.$notify({
                                title: '提示',
                                message: '404:Not found!',
                                type: 'error'
                            });
                        } else {
                            vm.$notify({
                                title: '提示',
                                message: '501:服务端未响应!',
                                type: 'error'
                            });
                        }
                    }
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '502:服务端未响应!',
                        type: 'error'
                    });
                }
            },
          handleLanguageChange(lang) {
            this.$store.commit('UPDATE_LANGUAGE', lang);
          }
        },
        data() {
            return {
              user: '',
              userName: '',
              mis_id: '',
              imgUrl: '',
              documentItems: null,
              is_manager: false,
              dropdown_item: {
                  disabled: true,
                  divided: true
              },
              languages: [
                { value: 'zh', label: '中文' },
                { value: 'en', label: 'English' }
              ]
            }
        },
    }
</script>

<style scoped>

    .blueheader {
        height: 60px;
        line-height: 60px;
        background: #fff;
        color: #000;
        -webkit-box-shadow: 0 2px 8px 0 rgba(93, 98, 106, 0.1);
        box-shadow: 0 2px 8px 0 rgba(93, 98, 106, 0.1);
        position: fixed;
        width: 100%;
        z-index: 1999;
    }

    .el-menu-vertical {
        position: fixed;
    }

    .el-menu-vertical:not(.el-menu--collapse) {
        width: 280px;
        min-height: 100%;
    }

    .el-menu.el-menu--horizontal {
        border-bottom: none;
    }

    .el-menu--horizontal > .el-menu-item.is-active {
        border-bottom: none;
        color: #000;
    }

    .el-menu--horizontal > .el-menu-item {
        float: left;
        height: 60px;
        line-height: 60px;
        margin: 0;
        border-bottom: 2px solid transparent;
        color: #409EFF;
    }

    .el-menu-item i.el-icon-s-promotion {
        color: #409EFF;
    }

    .headlogo {
        float: left;
        height: 60px;
        margin: 0 20px;
        width: 600px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .home_main {
        min-height: calc(100vh - 60px);
        padding: 20px;
        background-color: #f1f3f8;
    }

    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }

    .home_main .router-view-container {
        background-color: #fff;
        -webkit-box-shadow: 0 2px 8px 0 rgba(93, 98, 106, .1);
        box-shadow: 0 2px 8px 0 rgba(93, 98, 106, .1);
        padding: 20px;
        border-radius: 10px;
        height: calc(100% - 40px);
    }
    .selected {
      color: #409eff !important;
      font-weight: bold !important;
      background-color: #f0f9ff !important;
    }
</style>



// WEBPACK FOOTER //
// home.vue?29ba5891